import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
// import "./tiles.scss";
import "./Account.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getProfileApi } from "../../redux/features/profileSlice";
import { decryptFields, encryptFields } from "../../utils/kycStatus";

AOS.init();

function Account() {
  const { t } = useTranslation();
  const {
    goldTitle,
    silverTitle,
    portfolioTitle,
    historyTitle,
    profileTitle,
    gold,
    silver,
    portfolio,
    history,
    profile,
  } = t("home");

  const homeLinks = [
    {
      name: "home",
      img: "/images/gold_shield.png",
      title: "Digital Gold",
      link: "/dashboard/gold/buy",
      contentKey:
        "Experience the simplicity of owning gold digitally. Securely buy, store, and manage gold at your convenience, without the hassle of physical storage.",
    },
    {
      name: "home",
      img: "/images/silver_shield.png",
      title: "Digital Silver",
      link: "/dashboard/silver/buy",
      contentKey:
        "Unlock the potential of silver with a seamless digital platform. Purchase, store, and track silver securely and effortlessly, all from your device.",
    },
    // {
    //   name: "spotGold",
    //   img: "/images/jewellery_main.png",
    //   title: "Jewellery",
    //   // link: "/dashboard/spotGold",
    //   link: "/shop",
    //   contentKey:
    //     "Explore our beautiful collection of machine-made gold jewellery, crafted with precision for every special moment. Get modern designs with the trust and purity of gold.",
    // },
    // {
    //   name: "spotGold",
    //   img: "./goldFDLogo.png",
    //   title: "Gold FD",
    //   link: "/dashboard/goldFD",
    //   contentKey: gold,
    // },
    {
      name: "home",
      img: "/images/portfolioHome.png",
      title: portfolioTitle,
      link: "/dashboard/portfolio",
      contentKey:
        "Manage all your gold and silver assets in one place. Your portfolio lets you track and grow your wealth easily and transparently.",
    },
    // {
    //   name: "home",
    //   img: "/images/gold_sip.png",
    //   title: "Gold SIP",
    //   link: "/dashboard/gold-sip",
    //   contentKey:
    //     "Contribute a fixed amount regularly to accumulate gold over time. Enjoy a hassle-free way to build your gold savings securely, simply, and accessibly!",
    // },
    // {
    //   name: "home",
    //   img: "/images/silver_sip.png",
    //   title: "Silver SIP",
    //   link: "/dashboard/silver-sip",
    //   contentKey:
    //     "Set aside a fixed amount at regular intervals and watch your silver grow. It’s an easy and secure way to build your silver savings, perfect for every budget!",
    // },
    {
      name: "home",
      img: "/images/historyHome.png",
      // img2: "/images/history2.png",
      title: historyTitle,
      link: "/dashboard/history",
      contentKey: history,
    },
    {
      name: "home",
      img: "/images/profileHome.png",
      title: profileTitle,
      link: "/dashboard/profile",
      contentKey: profile,
    },
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const login = sessionStorage.getItem("token");
    if (!login) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    dispatch(getProfileApi());
  }, [dispatch]);

  const profileSliceResponse = useSelector(
    (state) => state?.profileSlice?.data?.data
  );

  useEffect(() => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

    userDetails = decryptFields(userDetails, ["pan", "bank", "address"]);
  }, []);

  useEffect(() => {
    if (profileSliceResponse?.length) {
      const { pan_no, account_no } = profileSliceResponse?.[0]?.kyc || {};

      const billingData =
        profileSliceResponse?.[0]?.billingAddress?.[0] ||
        profileSliceResponse?.[0]?.billAddressUser ||
        {};

      const { city, line1, line2, state } = billingData;

      let userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

      userDetails = decryptFields(userDetails, ["pan", "bank", "address"]);

      if (pan_no != null && pan_no !== "") {
        userDetails.pan = true;
      }

      if (account_no != null && account_no !== "") {
        userDetails.bank = true;
      }

      if (city && line1 && line2 && state) {
        userDetails.address = true;
      }

      userDetails = encryptFields(userDetails, ["pan", "bank", "address"]);

      localStorage.setItem("userDetails", JSON.stringify(userDetails));
    }
  }, [profileSliceResponse]);

  return (
    <div
      style={{ backgroundColor: "#fff", minHeight: "100vh", margin: "2rem 0" }}
    >
      <div
        className="Tiles"
        style={{
          width: "90%",
          margin: "auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "2rem",
            width: "100%",
          }}
        >
          {homeLinks.map((item, i) => (
            <div
              key={i}
              className="home-card"
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <Link
                to={item.link}
                style={{ width: "100%" }}
                className="account_card1"
              >
                <div
                  // className="tiles_card"
                  className="universal_card"
                  style={{ width: "100%" }}
                >
                  <div className="account_card">
                    <div>
                      <img
                        src={
                          hoveredIndex === i && item.img2 ? item.img2 : item.img
                        }
                        alt={t(item.title)}
                        // width="100%"
                        // height="150px"
                        // width="13.889vw"
                        className="account_img"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <h2>{t(item.title)}</h2>
                      <p>{item.contentKey}</p>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Account;
